// extracted by mini-css-extract-plugin
var _1 = "lueEKCDfHl08JL9fDb5i";
export { _1 as "span" }
